module.exports = "/_next/static/images/WarehouseData-c8a42234513c792e472cc2053a5d0c77.webp";